import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=41c265af"
import script from "./Repairs.vue?vue&type=script&lang=ts"
export * from "./Repairs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports